import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
    EconomicDevelopmentMapItemPopupContentComponent,
} from './components/economic-development-map-item-popup-content/economic-development-map-item-popup-content.component';
import { EconomicDevelopmentMapItem } from './definitions/economic-development-map-item';
import { MapWithSidebarModule } from '@ui/shared/feature-map';
import { AsyncPipe } from '@angular/common';
import {
    EconomicDevelopmentMapDetailsComponent,
} from './components/economic-development-map-item-details/economic-development-map-item-details.component';
import { BaseAppComponent } from '@ui/shared/feature-config';
import { FilterMapperComponent } from '@ui/shared/ui-filter';

@Component({
    selector: 'ui-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MapWithSidebarModule,
        AsyncPipe,
        EconomicDevelopmentMapDetailsComponent,
        FilterMapperComponent,
    ],
})
export class AppComponent extends BaseAppComponent<EconomicDevelopmentMapItem> {
    constructor() {
        super(EconomicDevelopmentMapItemPopupContentComponent);
    }
}
